import deepEqual from 'deep-equal';

import { parse } from 'papaparse';
import getDataApi from '../../api/get-data';

const asyncPapa = async csvData =>
  new Promise((resolve, reject) => {
    parse(csvData, {
      header: true,
      fastMode: true,
      skipEmptyLines: true,
      transform: (value, header) => {
        if (header === 'timestamp') {
          // we get UNIX timestamp from backend
          return Number(value);
        }
        if (header === 'count') {
          return Number(value);
        }
        return value;
      },
      complete: (result, file) => {
        resolve(result.data);
      },
      error: (err, file) => {
        reject(err);
      }
    });
  });

const fetchNewEvents = async () => {
  const [{ data: prevCSV }, { data: currentCSV }, { data: topIPCSV }, { data: todaySumCSV }] = await Promise.all([
    getDataApi.get('anonym_previous.csv'),
    getDataApi.get('anonym_current.csv'),
    getDataApi.get('top-geo.csv'),
    getDataApi.get('today-sum.csv')
  ]);

  return Promise.all([asyncPapa(prevCSV), asyncPapa(currentCSV), asyncPapa(topIPCSV), asyncPapa(todaySumCSV)]);
};

const distributeNewEvents = ({ commit, state }, newAllEventsArray) => {
  const { allEvents } = state;
  const lastTs = allEvents[allEvents.length - 1]?.timestamp;
  if (!lastTs || lastTs < newAllEventsArray[0]?.timestamp) {
    return commit('addNewEvents', newAllEventsArray);
  } else {
    const firstIndex = newAllEventsArray.findIndex(o => o.timestamp === lastTs);
    if (firstIndex !== -1) {
      let indexOfLast = firstIndex;
      while (newAllEventsArray[indexOfLast]?.timestamp !== lastTs) {
        indexOfLast += 1;
      }

      return commit('addNewEvents', newAllEventsArray.splice(indexOfLast));
    }
  }
};

let initialLoad = true;

export default {
  async fetchEvents({ commit, dispatch, state, rootState }) {
    const { unixTs } = rootState;
    const { allEvents } = state;
    const allEventsLen = allEvents.length;

    if (allEventsLen !== 0 && unixTs + 6 * 60 < allEvents[allEventsLen - 1]?.timestamp) {
      return;
    }

    // eslint-disable-next-line no-unused-vars
    const [prevData, currentData, topIP, todaySum] = await fetchNewEvents();

    if (!deepEqual(allEvents[allEventsLen - 1], currentData[currentData.length - 1])) {
      // there is a fresh set of data
      distributeNewEvents({ commit, state }, [...prevData, ...currentData]);
    }

    if (initialLoad) {
      initialLoad = false;
      commit('changeEventLoadingState', false);
      commit('setEventCount', todaySum[0].count);
      dispatch('mergePastEvents', topIP);
    }
  },

  refreshEvents({ commit, state, rootState }) {
    const { unixTs } = rootState;
    const { allEvents } = state;

    if (allEvents.length === 0) {
      return;
    }

    const firstIndex = allEvents.findIndex(o => o.timestamp >= unixTs - 3);
    const lastIndex = allEvents.findIndex(o => o.timestamp >= unixTs + 70);
    const newEvents = [];
    for (let i = firstIndex; i < lastIndex; i++) {
      newEvents.push({
        ...allEvents[i]
      });
    }
    commit('changeEvents', newEvents);
  },
  mergePastEvents({ commit, state }, newEvents) {
    const { pastEvents } = state;
    const shallowPast = [...pastEvents];
    let currentSum = state.eventCount;

    newEvents.forEach(newEvent => {
      currentSum += newEvent.count;
      const foundItemIndex = shallowPast.findIndex(o => {
        return o.geocountry === newEvent.geocountry;
      });

      if (foundItemIndex < 0) {
        // no item found
        const newMappedEvent = {
          sum: newEvent.count,
          geocountry: newEvent.geocountry,
          byType: {}
        };
        newMappedEvent.byType[newEvent.type] = newEvent.count;
        shallowPast.splice(shallowPast.length, 0, newMappedEvent);
      } else {
        const newMappedEvent = {
          ...shallowPast[foundItemIndex]
        };
        newMappedEvent.sum += newEvent.count;

        if (Object.prototype.hasOwnProperty.call(newMappedEvent.byType, newEvent.type)) {
          newMappedEvent.byType[newEvent.type] += newEvent.count;
        } else {
          newMappedEvent.byType[newEvent.type] = newEvent.count;
        }
        shallowPast.splice(foundItemIndex, 1, newMappedEvent);
      }
    });

    commit('setEventCount', currentSum);
    commit('setPastEvents', shallowPast);
  }
};
